import find from "lodash/find";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useMetadata } from "PFApp/components/activity_commons/use_metadata";
import { Stack } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

const metadataToOmit = ["interest_questions", "interest_statement_enabled"];

export const ActivityOverviewAvailability = () => {
  const { t } = useTranslation("activities", { keyPrefix: "show.details" });
  const activity = useCurrentActivity();

  const metadata = useMetadata({ activity, metadataToOmit });

  const availabilityInfo = find(metadata, { name: "availability" });

  if (!availabilityInfo || !availabilityInfo.text) {
    return null;
  }

  return (
    <Tile variant="light" paddingVariant="lg" data-qa-id="ActivityDetailsAvailability">
      <Stack gap="spacingLg">
        <Typography variant="h5">{t("availability")}</Typography>
        {availabilityInfo.text}
      </Stack>
    </Tile>
  );
};
